var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 63,
    viewBox: "0 0 61 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 63,
    rx: 8,
    fill: "#FFB516",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1607 19.5C25.8435 19.5 26.3929 20.035 26.3929 20.7V22.7H34.6071V20.7C34.6071 20.035 35.1565 19.5 35.8393 19.5C36.5221 19.5 37.0714 20.035 37.0714 20.7V22.7H38.7143C40.5266 22.7 42 24.135 42 25.9V40.3C42 42.065 40.5266 43.5 38.7143 43.5H22.2857C20.4734 43.5 19 42.065 19 40.3V25.9C19 24.135 20.4734 22.7 22.2857 22.7H23.9286V20.7C23.9286 20.035 24.4779 19.5 25.1607 19.5ZM25.1607 25.1H22.2857C21.8339 25.1 21.4643 25.46 21.4643 25.9V28.3H39.5357V25.9C39.5357 25.46 39.1661 25.1 38.7143 25.1H25.1607ZM21.4643 30.7V40.3C21.4643 40.74 21.8339 41.1 22.2857 41.1H38.7143C39.1661 41.1 39.5357 40.74 39.5357 40.3V30.7H21.4643Z",
    fill: "#FFB516"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendor);
export default __webpack_public_path__ + "static/media/calendor.5384e481ea275b1cf29094442eaa16e5.svg";
export { ForwardRef as ReactComponent };